import type {
  PrivacyPolicyField,
  PrivacyPolicyFieldType,
} from 'src/config/types';
import { isTimedComponentValid } from 'src/utils/timedComponent/timedComponentValidator';

export const isPrivacyPolicyBannerFieldValid = (
  privacyPolicyField?: PrivacyPolicyField<PrivacyPolicyFieldType>,
) => {
  if (!privacyPolicyField) {
    return false;
  }

  if (
    privacyPolicyField.type === 'CookieConsent' ||
    privacyPolicyField.type === 'PrivacyPolicy'
  ) {
    return isTimedComponentValid(privacyPolicyField.displayDates);
  }
  return false;
};
